import React from "react";
import { Outlet } from "react-router-dom";

export const MainLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden max-w-full">
      <main className="grow min-w-0">
        <Outlet />
      </main>
    </div>
  );
};
